<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Drawer from 'primevue/drawer';
import ArrowLeftIcon from '@primeicons/vue/arrow-left';
import AngleRightIcon from '@primeicons/vue/angle-right';
import TimesIcon from '@primeicons/vue/times';
import { Typography } from '@apparatix/library/core';
import { SectionIconography } from '../SectionIconography';

const router = useRouter();
const route = useRoute();

const isVisible = ref(false);

const invNumber = computed(() => (route.query.invNumber as string) || '');

const onDrawerHide = () => {
  if (route?.meta?.basePath) {
    // The timeout allows the drawer close animation to finish before we drop the
    // detail route, mirroring the CRM FlyoutHost behavior.
    setTimeout(() => router.replace({ path: route.meta.basePath as string }), 250);
  }
};

onMounted(() => isVisible.value = true);
</script>
<template>
  <Drawer
    v-model:visible="isVisible"
    position="right"
    class="crm-drawer-container"
    :pt="{
      root: {
        class: 'border-0 overscroll-none'
      },
      mask: {
        class: 'overscroll-none crm-drawer-mask'
      }
    }"
    modal
    @hide="onDrawerHide"
  >
    <template #container>
      <div class="flex flex-col w-full h-full overflow-y-auto bg-[var(--white)]">
        <div class="w-full h-[35px] shrink-0 flex items-center border-b border-[var(--p-content-border-color)]">
          <button
            class="grow-0 flex items-center justify-center w-[35px] h-full border-r border-[var(--p-content-border-color)] cursor-pointer"
            aria-label="Close drawer"
            @click="isVisible = false"
          >
            <TimesIcon />
          </button>
          <div
            class="grow flex gap-1 items-center h-full pl-3"
            :style="{ backgroundColor: SectionIconography['Inventory'].backgroundColor }"
          >
            <Typography variant="breadcrumb">
              {{ SectionIconography['Inventory'].singular }}
            </Typography>
            <template v-if="invNumber">
              <AngleRightIcon />
              <Typography variant="breadcrumb" :truncate="true">
                {{ invNumber }}
              </Typography>
            </template>
          </div>
          <button
            class="grow-0 h-full w-[35px] flex items-center justify-center bg-[var(--white)] border-l border-[var(--p-content-border-color)] cursor-pointer"
            aria-label="Back"
            @click="router.back"
          >
            <ArrowLeftIcon />
          </button>
        </div>
        <RouterView />
      </div>
    </template>
  </Drawer>
</template>
